/* fichier JS de base commun quelques soient les versions du projet web */

// import 'bootstrap'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'

// lazy loading => https://github.com/aFarkas/lazysizes
// import lazySizes from 'lazysizes'
import 'lazysizes/plugins/aspectratio/ls.aspectratio'
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.js'

// bootstrap => customisez bootstrap directement depuis un fichier custom et sélectionnez les modules communs utilisés sur toutes les pages du site au lieu de tout importer
import './scss/bootstrap'
// global styles
import './scss/custom'

// Scripts librairies
import { handle, sticky } from './js/libs/misc'
import './js/libs/utils'
import './js/components/cookie.js' // lazy loading https://github.com/aFarkas/lazysizes

// lazySizes.cfg.expand = 80
// lazySizes.cfg.expFactor = 1
$('body').removeClass('no-js')

// lazysizes : add simple support for background images :
document.addEventListener('lazybeforeunveil', (e) => {
  const bg = e.target.getAttribute('data-background')
  if (bg) e.target.style.backgroundImage = 'url(' + bg + ')'
})

// Scroll to top
async function getScrollToTop () {
  import(/* webpackChunkName: "scrollToTop" */ './js/components/scrollToTop.js')
}

// Swiper Carousel
async function getSwiperCarousel () {
  import(/* webpackChunkName: "swiperCarousel" */ './js/components/swiperCarousel.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Actions principales communes à toutes les pages
$(document).ready(function () {
  // sur le scroll
  const w = $(window)
  w.scroll(function () {
    if (w.scrollTop() >= 250 && !$('#scrollUp').length) { getScrollToTop() }
    sticky()
  })

  // gestion des boxes de service
  $('.service-box').waypoint(function () {
    import(/* webpackChunkName: "serviceBoxes" */ './scss/components/serviceBoxes.scss').then(() => {
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des articles d'actualités
  $('.newspost-item').waypoint(function () {
    import(/* webpackChunkName: "serviceBoxes" */ './scss/components/newspostItem.scss').then(() => {
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des cta
  $('.cta-section').waypoint(function () {
    import(/* webpackChunkName: "ctaSection" */ './scss/components/ctaSection.scss').then(() => {
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des carousel
  $('.swiper-carousel').waypoint(function () {
    getSwiperCarousel()
    this.destroy()
  }, {
    offset: '100%'
  })

  // boutons liens
  $('[data-toggle="link"]').on('click', function () {
    if ($(this).attr('data-target') === 'self') { document.location.href = $(this).attr('data-href') } else { window.open($(this).attr('data-href')) }
  })

  // ancre
  $.each($('.scroll'), function (i, elem) {
    $(elem).on('click', function (e) {
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($(t).length > 0) {
        $('html').animate({ scrollTop: ($(t).offset().top - $('#header').height()) - 20 }, { duration: 300, easing: 'linear' }, function () {
          $('html').animate({ scrollTop: ($(t).offset().top - $('#header').height()) - 20 }, { duration: 300, easing: 'linear' })
        })
      }
    })
  })

  // track event google
  $('.results-btn').each(function (i, elem) {
    $(elem).on('click', () => { // event sur bouton résultats et factures
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'results_btn') }
    })
  })
  $('.labels-btn').each(function (i, elem) {
    $(elem).on('click', () => { // event sur bouton étiquettes
      if (typeof (googletag) !== 'undefined') { gtag('event', 'labels_btn') }
    })
  })

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    Waypoint.refreshAll()
  })

  // handle sur toutes les pages du site
  handle()
  sticky()
})
